import CardsConfiguration from '../CardsConfiguration';
import CardsConfigurationsTable from '../Views/CardsConfigurationsTable.vue';
import CardConfigrationCreate from '../Views/CardConfigrationCreate.vue';
import CardConfigurationUpdate from '../Views/CardConfigurationUpdate.vue';

const CardsConfigurationsRoute = 
{
    path: '/cards-configuration',
    meta: {
        name: {
            en: 'Cards configuration',
            es: 'Configuración de tarjetas',
        }
    },
    component: CardsConfiguration,
    children: [
        {
            path: '/',
            component: CardsConfigurationsTable,
            meta: { name: 'Index', group: 'portaladministrativo.prices', path: 'cards_configuration', permission: 'READ'}
        },
        {
            path: 'create',
            component: CardConfigrationCreate,
            meta: { name: 'Create', group: 'portaladministrativo.prices', path: 'cards_configuration', permission: 'CREATE'}
        },
        {
            path: 'update/:id',
            component: CardConfigurationUpdate,
            meta: { name: 'Update', group: 'portaladministrativo.prices', path: 'cards_configuration', permission: 'UPDATE'}
        },
    ]
}

export default CardsConfigurationsRoute;